<template>
  <div class="content">
    <div class="timeLeft" v-if="haveTime==1&&mode!=2">
      <div class="timeLeftText1">
          您当前的学习模式：集训营模式 ( 剩余有效学时：<span style="font-family:PingFang SC;font-weight: 600;">{{djsDay}}</span>&nbsp; 天 &nbsp;<span style="font-family:PingFang SC;font-weight: 600;">{{djsHour}}</span>&nbsp; 小时 &nbsp;<span style="font-family:PingFang SC;font-weight: 600;">{{djsMin}}</span>&nbsp; 分钟 &nbsp;<span style="font-family:PingFang SC;font-weight: 600;">{{djsSecond}}</span>&nbsp; 秒  ) 
      </div>
      <div class="changeMode" @click="shadowTip=1;dajishiOnTip()">
          <div class="changeModeText1">切换至自主学习模式</div>
          <img src="~@/assets/globalCourse/白色箭头.png" alt="" class="changeModeIcon">
      </div>
    </div>
    <div class="timeLeft" v-if="haveTime==2&&mode!=2">
      <div class="timeLeftText1">
          您的有效学时已用尽，无法申请证书，但您可以继续学习
      </div>
      <div class="changeMode" @click="shadowTip=1;dajishiOnTip()">
          <div class="changeModeText1">切换至自主学习模式</div>
          <img src="~@/assets/globalCourse/白色箭头.png" alt="" class="changeModeIcon">
      </div>
    </div>
    <div class="timeLeft" v-if="haveTime==3&&mode!=2" @click="$router.push('/graduationCertificate')">
        您已结业！<span style="cursor: pointer;">申请结业证书</span>
        <img src="~@/assets/globalCourse/白色箭头.png" alt="" class="timeLeftIcon">
    </div>
    <div class="timeLeft" v-if="haveTime==4&&mode!=2">您已完成全部学习内容</div>
    <div class="timeLeft" v-if="mode==2">您当前为自主学习模式，可自由选择课程任意部分学习</div>

    <div class="content1280">
      <div class="top">
        <div class="titleText1" @click="$router.push('/')">首页 /</div>
        <div
          class="titleText1"
          @click="$router.push('/globalCourse')"
          style="left: 53px; width: 78px"
        >
          线上课堂 /
        </div>
        <div
          class="titleText1"
          style="left: 138px; width: 500px; color: #3a3a3a; font-weight: 600"
        >
          {{ name }}
        </div>
      </div>
    </div>
    <div class="courseTitle">
      <div
        class="courseTitle"
        style="width: 1280px; left: calc(50% - 640px); position: absolute"
      >
        <img :src="avatar" alt="" class="courseBackground" />
        <div class="courseTitleText1">{{ name }}</div>
        <img src="~@/assets/globalCourse/全部完成.png" alt="" class="courseStatus" v-if="learnStatus==1&&mode!=2">
        <img
          src="~@/assets/globalCourse/吉林一号原创.png"
          alt=""
          class="courseDetailImg1"
          v-if="originalStatus == 1"
        />
        <img
          src="~@/assets/globalCourse/入门级.png"
          alt=""
          class="courseDetailImg2"
          v-if="level == 0"
        />
        <img
          src="~@/assets/globalCourse/进阶级.png"
          alt=""
          class="courseDetailImg2"
          v-if="level == 1"
        />
        <img
          src="~@/assets/globalCourse/专家级.png"
          alt=""
          class="courseDetailImg2"
          v-if="level == 2"
        />
        <div class="courseTitleText2">创建日期：{{ createTime }}</div>
        <div
          class="courseTitleText2"
          style="left: 758px"
          v-if="updateTime != '' && updateTime != null"
        >
          更新日期：{{ updateTime }}
        </div>
        <div class="courseTitleText2" style="top: 204px; width: 500px">
          {{ desp }}
        </div>
        <div
          class="courseTitleText2"
          style="top: 302px; width: 150px; left: 660px"
        >
          {{ evaluateCount }} 人评价
        </div>
        <!-- 星星 -->
        <div class="starLeft" id="starLeft1">
          <img src="~@/assets/globalCourse/评价3.png" alt="" class="star" />
        </div>
        <div class="starLeft" id="starLeft2" style="left: 557px">
          <img src="~@/assets/globalCourse/评价3.png" alt="" class="star" />
        </div>
        <div class="starLeft" id="starLeft3" style="left: 580px">
          <img src="~@/assets/globalCourse/评价3.png" alt="" class="star" />
        </div>
        <div class="starLeft" id="starLeft4" style="left: 603px">
          <img src="~@/assets/globalCourse/评价3.png" alt="" class="star" />
        </div>
        <div class="starLeft" id="starLeft5" style="left: 626px">
          <img src="~@/assets/globalCourse/评价3.png" alt="" class="star" />
        </div>
        <img src="~@/assets/globalCourse/评价4.png" alt="" class="star1" />
        <img
          src="~@/assets/globalCourse/评价4.png"
          alt=""
          class="star1"
          style="left: 557px"
        />
        <img
          src="~@/assets/globalCourse/评价4.png"
          alt=""
          class="star1"
          style="left: 580px"
        />
        <img
          src="~@/assets/globalCourse/评价4.png"
          alt=""
          class="star1"
          style="left: 603px"
        />
        <img
          src="~@/assets/globalCourse/评价4.png"
          alt=""
          class="star1"
          style="left: 626px"
        />

        <div style="cursor: pointer">
          <img
            src="~@/assets/globalCourse/分享icon.png"
            alt=""
            class="courseDetailImg3"
          />
          <div
            class="courseTitleText2"
            style="top: 302px; width: 32px; left: 799px"
            id="articleHref"
            @click="copyUrl()"
          >
            分享
          </div>
        </div>
        <div
          class="courseTitleButton1"
          @click="goStudy1()"
          v-if="startStudy == 1&&mode!=2"
        >
          开始学习
        </div>
        <div
          class="courseTitleButton2"
          @click="goStudy2()"
          v-if="startStudy == 2&&mode!=2"
        >
          已学习 {{ videoNum }}/{{ videoListLength }} 课
        </div>
        <div
          class="courseTitleButton3"
          @click="goStudy3()"
          v-if="startStudy == 3&&mode!=2"
        >
          去完成作业
        </div>
        <div
          class="courseTitleButton1"
          @click="goStudy4()"
          v-if="startStudy == 4&&mode!=2"
        >
          复习回看
        </div>
      </div>
    </div>
    <div class="courseContent">
      <div class="courseCon1280">
        <div
          :class="pageShow == 1 ? 'conText1' : 'conText1-s'"
          @click="pageShow = 1"
        >
          课程内容
        </div>
        <div
          :class="pageShow == 2 ? 'conText2' : 'conText2-s'"
          @click="getCommentData "
        >
          评论 ( {{ commentLength }} )
        </div>
        <!-- 课程内容 -->
        <div v-show="pageShow == 1">
          <!-- 课程评价 -->
          <div style="margin-bottom: -95px" v-if="videoWatchOver">
            <div class="context3">课程评价</div>
            <img
              src="~@/assets/globalCourse/评价2.png"
              alt=""
              class="star2"
              @click="assessStar(1)"
              v-if="assessStarNum == 0"
            />
            <img
              src="~@/assets/globalCourse/评价3.png"
              alt=""
              class="star2"
              @click="assessStar(1)"
              v-if="assessStarNum >= 1"
            />
            <img
              src="~@/assets/globalCourse/评价2.png"
              alt=""
              class="star2"
              @click="assessStar(2)"
              v-if="assessStarNum <= 1"
            />
            <img
              src="~@/assets/globalCourse/评价3.png"
              alt=""
              class="star2"
              @click="assessStar(2)"
              v-if="assessStarNum >= 2"
            />
            <img
              src="~@/assets/globalCourse/评价2.png"
              alt=""
              class="star2"
              @click="assessStar(3)"
              v-if="assessStarNum <= 2"
            />
            <img
              src="~@/assets/globalCourse/评价3.png"
              alt=""
              class="star2"
              @click="assessStar(3)"
              v-if="assessStarNum >= 3"
            />
            <img
              src="~@/assets/globalCourse/评价2.png"
              alt=""
              class="star2"
              @click="assessStar(4)"
              v-if="assessStarNum <= 3"
            />
            <img
              src="~@/assets/globalCourse/评价3.png"
              alt=""
              class="star2"
              @click="assessStar(4)"
              v-if="assessStarNum >= 4"
            />
            <img
              src="~@/assets/globalCourse/评价2.png"
              alt=""
              class="star2"
              @click="assessStar(5)"
              v-if="assessStarNum <= 4"
            />
            <img
              src="~@/assets/globalCourse/评价3.png"
              alt=""
              class="star2"
              @click="assessStar(5)"
              v-if="assessStarNum >= 5"
            />
            <div style="cursor: pointer" @click="pageShow = 2">
              <img
                src="~@/assets/globalCourse/写评论.png"
                alt=""
                class="star2"
                style="margin-left: 105px; width: 17px"
              />
              <div class="context6">写评论</div>
            </div>
            <div class="conLine4"></div>
          </div>
          <div class="context3">课程表</div>
          <!-- 课程循环 -->
          <div
            class="smallCourseDetail"
            v-for="(item, index) in videoList"
            :key="index"
          >
          <span v-if="mode!=2">
              <img
                src="~@/assets/globalCourse/1未.png"
                alt=""
                class="weiwancheng"
                v-if="index == 0 && item.learnStatus == 0"
              />
              <img
                src="~@/assets/globalCourse/1已.png"
                alt=""
                class="weiwancheng"
                v-if="index == 0 && item.learnStatus == 1"
              />
              <img
                src="~@/assets/globalCourse/2未.png"
                alt=""
                class="weiwancheng"
                v-if="index == 1 && item.learnStatus == 0"
              />
              <img
                src="~@/assets/globalCourse/2已.png"
                alt=""
                class="weiwancheng"
                v-if="index == 1 && item.learnStatus == 1"
              />
              <img
                src="~@/assets/globalCourse/3未.png"
                alt=""
                class="weiwancheng"
                v-if="index == 2 && item.learnStatus == 0"
              />
              <img
                src="~@/assets/globalCourse/3已.png"
                alt=""
                class="weiwancheng"
                v-if="index == 2 && item.learnStatus == 1"
              />
              <img
                src="~@/assets/globalCourse/4未.png"
                alt=""
                class="weiwancheng"
                v-if="index == 3 && item.learnStatus == 0"
              />
              <img
                src="~@/assets/globalCourse/4已.png"
                alt=""
                class="weiwancheng"
                v-if="index == 3 && item.learnStatus == 1"
              />
          </span>
          <span v-if="mode==2">
            <img
                src="~@/assets/globalCourse/1.png"
                alt=""
                class="weiwancheng"
                v-if="index == 0 "
              />
              <img
                src="~@/assets/globalCourse/2.png"
                alt=""
                class="weiwancheng"
                v-if="index == 1 "
              />
              <img
                src="~@/assets/globalCourse/3.png"
                alt=""
                class="weiwancheng"
                v-if="index == 2 "
              />
          </span>
            

            <div class="videoArea">
              <img
                src="~@/assets/globalCourse/视频icon(小课时).png"
                alt=""
                class="videoIcon"
              />
              <div
                class="smallCourseTitle"
                @click="goVideo(item.id, index)"
                style="cursor: pointer"
              >
                {{ item.title }}
              </div>
              <div
                class="smallCourseTitle"
                style="margin-left: 17px; color: #979797"
              >
                ( {{ videoTimeList[index] }} )
              </div>
              <img
                src="~@/assets/globalCourse/完成icon.png"
                alt=""
                class="wanchengIcon"
                v-if="item.learnStatus == 1&&mode!=2"
              />
            </div>
            <div class="videoArea" style="margin-top: 12px">
              <img
                src="~@/assets/globalCourse/去做作业_金.png"
                alt=""
                class="videoIcon"
                style="height: 22px"
              />
              <div
                class="smallCourseTitle1"
                @click="
                  goHomework(
                    item.learnStatus,
                    item.courseHomework.id,
                    item.homeworkStatus,
                    item.title
                  )
                "
                v-if="item.courseHomework != null && item.courseHomework != ''"
              >
                {{ item.courseHomework.name }}
              </div>
              <img
                src="~@/assets/globalCourse/完成icon.png"
                alt=""
                class="wanchengIcon1"
                v-if="
                  item.homeworkStatus == 1 &&
                  item.courseHomework != null &&
                  item.courseHomework != ''&&mode!=2
                "
              />
            </div>
          </div>
          <div class="conLine3"></div>
          <!-- 课程简介 -->
          <div class="context3" style="margin-top: 54px">课程简介</div>
          <div class="context5">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ introduction }}
          </div>
          <div class="conLine3" style="margin-top: 53px"></div>
          <div class="context3" style="margin-top: 54px">主讲人</div>
          <div class="context5">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ teacherInfo }}
          </div>
          <div class="conLine3" style="margin-top: 53px"></div>
          <div class="context3" style="margin-top: 54px">
            使用条款及版权声明
          </div>
          <div class="context5" style="margin-bottom: 220px">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;CopyRight © 2023
            长光卫星技术股份有限公司。本课程版权为长光卫星技术股份有限公司所有。未经本公司书面许可，任何单位和个人不得以任何形式摘抄、复制本课程的部分或全部内容，并以任何形式传播。
          </div>
        </div>
        <!-- 评论 -->
        <div v-show="pageShow == 2">
          <div class="goLogin" id="goLoginId" v-show="!commentIsable">
            请<span
              style="color: #c49760; cursor: pointer; font-weight: 600"
              @click="checkAndHandleAuthentication()"
              >实名</span
            >后发表评论
          </div>
          <textarea
            v-model="contentDes"
            id="textareaId"
            class="writeComment"
            placeholder="请输入评论内容，不超过200字"
            @input="areaNumJudge"
            v-show="commentIsable"
          ></textarea>
          <div class="textareaTip" v-if="textOverFlow">内容不能超过200字</div>
          <div
            class="commentEnter"
            @click="commentEnter()"
            v-if="commentIsable"
          >
            发布
          </div>
          <!-- 评论循环 -->
          <div
            class="commentContent"
            v-for="(item, index) in commentList"
            :key="index"
            :id='"a"+item.id'
          >
            <div
              style="
                position: relative;
                width: 1280px;
                height: 40px;
                margin-top: 0;
                margin-left: 0;
              "
            >
              <img
                :src="item.userAvatar"
                alt=""
                class="userImg"
                v-if="item.userAvatar!=null && item.teacherStatus==0"
              />
              <img
                src="~@/assets/globalCourse/默认头像.png"
                alt=""
                class="userImg"
                v-if="item.userAvatar == null && item.teacherStatus==0"
              />
              <img
                src="~@/assets/globalCourse/讲师头像.png"
                alt=""
                class="userImg"
                v-if="item.teacherStatus==1"
              />
              <div class="userName">{{ item.userName }}</div>
            </div>
            <div class="userComment">{{ item.content }}</div>
            <div
              style="
                position: relative;
                width: 1225px;
                height: 20px;
                margin-top: 24px;
                margin-left: 55px;
              "
            >
              <div class="userTime">{{ showtime(item.createTime) }}</div>
              <div
                class="userTime"
                style="left: 990px; cursor: pointer"
                v-if="item.userId == userId"
                @click="deleteComment(item.id, '', index, '')"
              >
                删除
              </div>
              <div style="cursor: pointer" @click="replyComment(index)">
                <img
                  src="~@/assets/globalCourse/回复评论.png"
                  alt=""
                  class="replyIcon"
                />
                <div class="userTime" style="left: 1109px">回复</div>
              </div>
              <img
                src="~@/assets/globalCourse/点赞_未赞.png"
                alt=""
                class="dianzanIcon"
                v-if="item.likeStatus == 0"
                @click="dianZanOff(item.id, '')"
              />
              <img
                src="~@/assets/globalCourse/点赞_已赞.png"
                alt=""
                class="dianzanIcon"
                v-if="item.likeStatus == 1"
                @click="dianZanOff(item.id, '')"
              />
              <div class="userTime" style="left: 1196px">
                {{ item.likeCount }}
              </div>
            </div>
            <textarea
              v-model="contentDes1[index]"
              :id="'contentDesId' + index"
              class="writeComment"
              style="margin-top: 27px; margin-bottom: 26px"
              :placeholder="'回复' + item.userName + '：'"
              @input="areaNumJudge1(index)"
              v-show="commentIsable1[index]"
            ></textarea>
            <div
              class="textareaTip"
              style="margin-top: -25px; margin-bottom: 0px"
              v-if="textOverFlow1[index]"
            >
              内容不能超过200字
            </div>
            <div
              class="commentEnter"
              @click="commentEnter1(index, item.id,item.replyId)"
              style="margin-top: -20px"
              v-if="commentIsable1[index]"
            >
              发布
            </div>
            <!-- 回复循环 -->
            <div
              class="commentReply"
              v-if="commentList[index].replyList && commentList[index].replyList.length != 0"
            >
              <div
                v-for="(item1, index1) in commentList[index].replyList"
                :key="index1"
              >
                <div
                  style="
                    position: relative;
                    width: 500px;
                    height: 40px;
                    margin-top: 20px;
                    margin-left: 27px;
                  "
                >
                  <img
                    :src="item1.fromAvatar"
                    alt=""
                    class="userImg"
                    style="width: 28px; height: 28px"
                    v-if="item1.fromAvatar!=null && item1.teacherStatus==0"
                  />
                  
                  <img
                    src="~@/assets/globalCourse/默认头像.png"
                    alt=""
                    class="userImg"
                    style="width: 28px; height: 28px"
                    v-if="
                      item1.fromAvatar == null && item1.teacherStatus==0
                    "
                  />
                  <img
                    src="~@/assets/globalCourse/讲师头像.png"
                    alt=""
                    class="userImg"
                    style="width: 28px; height: 28px"
                    v-if="
                      item1.teacherStatus==1
                    "
                  />
                  <div
                    class="userName"
                    style="
                      left: 39px;
                      font-size: 14px;
                      height: 28px;
                      line-height: 28px;
                    "
                  >
                    {{ item1.fromName }}
                  </div>
                </div>
                <div
                  class="userComment"
                  style="margin-top: 3px; margin-left: 66px"
                >
                  回复{{ item1.toName }}：{{ item1.content }}
                </div>
                <div
                  style="
                    position: relative;
                    width: 1225px;
                    height: 20px;
                    margin-top: 7px;
                    margin-left: 0px;
                  "
                >
                  <div class="userTime" style="left: 66px">
                    {{ showtime(item1.createTime) }}
                  </div>
                  <div
                    class="userTime"
                    style="left: 990px; cursor: pointer"
                    v-if="item1.fromUid == userId"
                    @click="deleteContent(item.id, item1.id, index, index1)"
                  >
                    删除
                  </div>
                  <div
                    style="cursor: pointer"
                    @click="replyComment2(index, index1)"
                  >
                    <img
                      src="~@/assets/globalCourse/回复评论.png"
                      alt=""
                      class="replyIcon"
                    />
                    <div class="userTime" style="left: 1109px">回复</div>
                  </div>
                  <img
                    src="~@/assets/globalCourse/点赞_未赞.png"
                    alt=""
                    class="dianzanIcon"
                    v-if="item1.likeStatus == 0"
                    @click="dianZanOff(item.id, item1.id)"
                  />
                  <img
                    src="~@/assets/globalCourse/点赞_已赞.png"
                    alt=""
                    class="dianzanIcon"
                    v-if="item1.likeStatus == 1"
                    @click="dianZanOff(item.id, item1.id)"
                  />
                  <div class="userTime" style="left: 1196px">
                    {{ item1.likeCount }}
                  </div>
                </div>
                <textarea
                  v-model="contentDes2[index1]"
                  :id="'contentDes2Id' + index1"
                  class="writeComment-s"
                  :placeholder="'回复' + item1.fromName + '：'"
                  @input="areaNumJudge2(index1)"
                  v-show="commentIsable2[index][index1]"
                ></textarea>
                <div
                  class="textareaTip"
                  style="margin-top: -25px; margin-bottom: 0px"
                  v-if="textOverFlow2[index1]"
                >
                  内容不能超过200字
                </div>
                <div
                  class="commentEnter"
                  @click="commentEnter2(index1, item.id, item1.id)"
                  style="margin-top: -20px; margin-right: 24px"
                  v-if="commentIsable2[index][index1]"
                >
                  发布
                </div>
              </div>
            </div>
            <div
              class="commentLine"
              v-if="index != commentList.length - 1"
            ></div>
          </div>
          <!-- 查看更多评论 -->
          <div
            class="clickMoreComment"
            v-if="moreComment"
            @click="moreCommentClick()"
          >
            查看更多评论
          </div>
          <div
            class="clickMoreComment"
            v-if="!moreComment"
            style="margin-bottom: 227px"
          >
            没有更多内容了
          </div>
        </div>
      </div>
    </div>
    <div class="shadow" v-if="shadow == 1">
      <div class="tip">
        <div class="tipText1">提示</div>
        <div class="tipText2">
          请您先完成《{{ courseTitle }}》的学习，再做该课程作业
        </div>
        <div class="tipText3" @click="shadow = 0">确定</div>
      </div>
    </div>
    <div class="shadow" v-if="shadow == 2">
      <div class="shadow2White">
        <div class="text4">请您知悉</div>
        <div class="text6">
          亲爱的用户，在开始学习之前请您认真阅读如下内容：
          <br />&nbsp; &nbsp; &nbsp;i. 若您在开始学习起计时<span
            style="color: #c49760"
            >90天内</span
          >完成全部学习内容并提交全部作业，您将获得吉<br />林一号颁发的结业证书，并有资格参加年度优秀学员的评比；
          <br />&nbsp; &nbsp; &nbsp;ii.若您未能<span
            style="color: #c49760"
            >90天内</span
          >内完成全部学习内容并提交全部作业，则不能获得结业证书且<br />无法参加年度优秀学员评比，但您可以随时继续学习剩余课程。
          <br />&nbsp; &nbsp;
          &nbsp;iii.我们对线上学习或线下集训获得结业认证的学员给予相同的<span
            style="color: #c49760; text-decoration: underline; cursor: pointer"
            @click="
              shadow = 3;
              xianxia = true;
            "
            >激励政策</span
          >
        </div>
        <img src="~@/assets/globalCourse/未选中.png" alt="" class="xieyiSelect" v-if="!xieyi" @click="xieyi=true">
        <img src="~@/assets/globalCourse/选中.png" alt="" class="xieyiSelect" v-if="xieyi" @click="xieyi=false">
        <div class="xieyiText">我已阅读并同意<span style="color:#C49760;text-decoration: underline; cursor: pointer" @click="shadow=4">《吉林一号•遥感开发者培训班全球课堂用户协议》</span> </div>
        <div class="shadow2Button" v-if="waiting||xieyi==false">我已知悉 ({{ second }}s)</div>
        <div class="shadow2Button-s" v-if="waiting==false&&xieyi==true" @click="firstStudy1()">
          我已知悉
        </div>
      </div>
    </div>
    <div class="shadow" v-if="shadow == 3">
      <div class="shadowWhite">
        <div class="text4">学员激励政策</div>
        <div class="text5">
          1、取得结业认证的优秀学生学员，在符合公司硬性招聘条件的情况下优先发放offer
          <br />&nbsp; &nbsp; &nbsp;或实习机会；
          <br />2、免费获得实践类课程所需资源(如高分辨样例数据)，取得结业认证的优秀学员可获
          <br />&nbsp; &nbsp;
          &nbsp;得生态开放商城付费生态会员与高分辨数据兑换券；
          <br />3、获得结业认证的学员所在组织有机会成为吉林一号生态合作伙伴；
          <br />4、获得结业认证的优秀学员有机会获得吉林一号开发者官方认证资格；
          <br />5、获得结业认证的学员可获得在线商城永久学员限定认证勋章，获评认证等级，线
          <br />&nbsp; &nbsp; &nbsp;下集训营学员可额外获得实体结业证书。
          <br /><span style="font-size: 14px; color: #c49760"
            >注：该激励政策最终解释权归长光卫星技术股份有限公司，政策可能根据实际运行情况调整</span
          >
        </div>
        <div class="shadowButton" @click="xianxiaJudge()">确定</div>
      </div>
    </div>
    <div class="shadow" v-if="shadow == 4">
      <div class="shadow3White">
        <div class="text4" style="width: 500px;left: calc(50% - 250px);">吉林一号•遥感开发者培训班全球课堂用户协议</div>
        <div class="xieyiText2">如果您选择接受本条款，即表示您同意接受协议各项条件的约束。如果您不同意本服务条款，您可以主动停止使用吉林一号•遥感开发者培训班全球课堂（以下简称“本网站”）提供的服务。您若有违反本条款规定，本网站有权随时中止或终止您的使用资格并保留追究相关法律责任的权利。本协议条款一旦发生变更，本网站将在网页上公布修改内容。修改后的服务条款一旦在网页上公布即有效代替原来的服务条款。
          <br><br>一、产品保护条款<br>1、本网站提供的所有课程内容与服务中包含的任何文字、图表、音频、视频（包括但不限于图表、动画、音频、视频、界面、数据和程序、代码、文档）等信息或材料均用于非商业用途、非盈利目的。
          <br><br>2、您须明白，使用本协议产品涉及到互联网服务，可能会受到各个环节不稳定因素的影响。因此服务存在不可抗力、计算机病毒或黑客攻击、系统不稳定、用户所在位置、用户关机以及其他任何技术、互联网络、通信线路原因等造成的服务中断或不能满足用户要求的风险。您须承担以上风险，本网站不作担保。
          <br><br>3、如本网站的系统发生故障影响到本协议的正常运行，本网站承诺在第一时间内与相关单位配合，及时处理进行修复。但您因此而产生的经济损失，本网站不承担责任。此外，本网站保留不经事先通知为维修保养、升级或其他目的暂停本协议任何部分的权利。
          <br><br>4、使用本协议必须遵守国家有关法律和政策等，维护国家利益，保护国家安全，并遵守本条款，对于您违法或违反本条款的使用(包括但不限于言论发表、传送等)而引起的一切责任，由您负全部责任，概与本网站无关，导致损失的，本网站有权要求赔偿，并有权立即停止向其提供服务，保留相关记录，并保留配合司法机关追究法律责任的权利。
          <br><br>5、您同意个人隐私信息是指那些能够对您进行个人辨识或涉及个人通信的信息，包括下列信息：您的姓名、身份证号、手机号码、IP地址、电子邮件地址信息。而非个人隐私信息是指您登录的账号、对软件的操作状态以及使用习惯等您的操作记录信息和其他一切个人隐私信息范围外的普通信息。本网站将会采取合理的措施保护您的个人隐私信息，除法律或有法律赋予权限的政府部门要求或您同意等原因外，本网站未经您同意不向第三方公开、透露您个人隐私信息。您同意，为了运营和改善本网站的技术和服务，本网站可以在无须再另行通知或提示您的情况下，自己收集使用您的非个人隐私信息，以有助于本网站向用户提供更好的用户体验和提高服务质量。
          <br><br>二、用户使用须知 <br>特别提醒您，使用互联网必须遵守国家有关的政策和法律，如刑法、国家安全法、保密法、计算机信息系统安全保护条例等，保护国家利益，保护国家安全，对于违法使用互联网络而引起的一切责任，由您负全部责任。
          <br><br>1、您不得使用本网站发送或传播任何妨碍社会治安或非法、虚假、骚扰性、侮辱性、恐吓性、伤害性、破坏性、挑衅性、淫秽色情性等内容的信息。
          <br><br>2、您不得使用本网站发送或传播敏感信息和违反国家法律制度的信息。
          <br><br>3、您保证以真实的身份注册使用本网站，向本网站所提供的个人身份资料信息真实、完整、有效，依据法律规定和约定对所提供的信息承担相应的法律责任。如果资料发生变化，您应及时更改。在安全完成本协议的登记程序后，您应维持密码及账号的机密安全。您应对任何人利用您的密码及账号所进行的活动负完全的责任，本网站无法对非法或未经您授权使用您账号及密码的行为做出甄别，因此本网站不承担任何责任。
          <br><br>4、盗取他人号码或利用网络通讯骚扰他人，均属于非法行为。您不得采用测试、欺骗等任何非法手段，盗取其他用户的账号和对他人进行骚扰。
          <br><br>5、本网站在此郑重提请您注意，任何经由本协议以上传、下载、张贴、电子邮件或任何其他方式传送的资讯、资料、文字、软件、音乐、音讯、照片、图形、视讯、信息、用户的登记资料或其他资料等（以下简称“内容”），无论系公开还是私下传送，均由内容提供者承担责任。同时，为了提高、改进本网站各种服务的用户体验，您同意本网站对凡是您经由本服务通过上传、张贴等任何方式发布到本网站的任何文字、图片及其他信息资料等进行无偿的修改、复制、传播等使用。本网站无法监控经由本协议传送之内容，也无法对用户的使用行为进行全面控制，因此不保证内容的合法性、正确性、完整性、真实性或品质等；您已预知使用本服务时，可能会接触到令人不快、不适当或令人厌恶之内容，并同意将自行加以判断并承担所有风险，而不依赖于本网站。但在任何情况下，本网站有权依法停止任何前述内容的服务并采取相应行动，包括但不限于暂停用户使用本协议的全部或部分，保存有关记录，并向有关机关报告。但本网站有权(但无义务)依其自行之考量，拒绝和删除可经由本协议提供之违反本条款的或其他引起本网站或其他用户反感的任何内容。
          <br><br>6、本网站提供服务属于群体类产品，使用本网站服务的用户之间引发的任何纠纷本网站将不负责任。
          <br><br>7.本网站保留修改或增补本协议内容的权利。本协议的修改文本将公告于本网站。修改文本一旦公布则立即生效，且对生效前的用户同样适用。若您在本协议内容发生修订后，继续使用本服务的，则视为您同意最新修订的协议内容；否则您须立即停止使用本服务。
          <br><br>8、因本协议引起的或与本协议有关的争议，均适用中华人民共和国法律。
          <br><br>三、用户学习服务<br>本网站提供了大量的视频学习课程。您同意、理解并遵循以下条款，也同时适用，对双方均有约束力：
          <br><br>1、非经本网站书面同意您不得擅自使用、修改、复制、传播、改变、散布、发行或发表本网站所提供的内容和服务。如有违反，您同意承担由此给本网站造成的一切损失。
          <br><br>2、您在本网站学习中所产生的评论、笔记、答疑、讨论，代码，个人作品（包括但不限于代码、图片、数据等），本网站均有权在本网站及相关宣传媒体/品进行展示，并无须支付任何费用。
          <br><br>3、您除了可以按照本协议的约定在本网站使用学习之外，不得进行任何侵犯本网站的知识产权的行为，或者进行其他的有损于本网站或其他用户合法权益的行为。本网站有权采取技术措施防止您从事这些行为，包括但不限于：
          <br><span style="padding-left: 40px;">（1）修改本网站课程中的版权信息，或者擅自修改本网站课程的名称； </span>  
          <br><span style="padding-left: 40px;">（2）进行任何本网站学习公平性或者其他影响其他用户正常秩序的行为，如主动或被动刷积分、合伙作弊、使用外挂或者其他的作弊软件、利用BUG（又叫“漏洞”或者“缺陷”）来获得不正当的非法利益，或者利用互联网或其他方式将外挂、作弊软件、BUG公之于众；</span>
          <br><span style="padding-left: 40px;"></span>（3）利用劫持域名服务器等技术非法侵入、破坏用户学习的服务器软件系统，或者修改、增加、删除、窃取、截留、替换服务器软件系统中的数据，或者非法挤占本网站的服务器空间，或者实施其他的使之超负荷运行的行为；
          <br><span style="padding-left: 40px;"></span>（4）进行任何诸如发布广告、推广的商业行为，或者进行任何非法的侵害本网站利益的行为等；
          <br><span style="padding-left: 40px;"></span>（5）冒充本网站管理员或是官方工作人员发布任何诈骗或虚假信息；
          <br><span style="padding-left: 40px;"></span>（6）发表、转发、传播含有谩骂、诅咒、诋毁、攻击、诽谤、侵害本网站和/或第三方权益内容的，或者含有封建迷信、淫秽、色情、下流、恐怖、暴力、凶杀、赌博、反动、扇动民族仇恨、危害祖国统一、颠覆国家政权等让人反感、厌恶的内容的非法言论，或者设置含有上述内容的用户昵称；
          <br><span style="padding-left: 40px;"></span>（7）在日常学习环节中进行恶意刷分、恶意评论，恶意回答回复等恶意破坏本网站公共秩序的行为；
          <br><span style="padding-left: 40px;"></span>（8）利用用户发布评论、评价、问答、回答、回复等故意传播恶意程序或计算机病毒，或者发表、转发、传播侵犯第三方知识产权、肖像权、姓名权、名誉权、隐私或其他合法权益的文字、图片、照片、程序、视频、图像和/或动画等资料。
          <br><br>4、您充分理解到：用户学习观看使时的相关用户数据将会占据本网站服务器空间。长期保留您在使用和享受本网站提供的学习服务的过程中所产生的全部数据，将会大量地挤占服务器空间，影响整个本网站服务器的运行速度，增加本网站的运营成本。因此，本网站将会定期将服务器上存储的一些过往的学习数据转移或者永久地删除。
          <br><br>5、您如有任何违反协议或相关法规的，本网站有权采取下列措施当中的一种或几种：
          <br><span style="padding-left: 40px;"></span>（1）立即断开您当前使用的计算机与本网站服务器之间的网络连接；
          <br><span style="padding-left: 40px;"></span>（2）暂时禁止您凭借当前使用的本网站账户登录本网站学习使用；
          <br><span style="padding-left: 40px;"></span>（3）降低或者清除您当前使用的本网站账户在学习当中的历史记录；
          <br><span style="padding-left: 40px;"></span>（4）永久性地、不可撤销地将您发布的广告、虚假信息或者非法言论删除，或者采取其他的阻止其传播的措施；
          <br><span style="padding-left: 40px;"></span>（5）永久性地、不可撤销地将您非法获取的历史记录清楚；
          <br><span style="padding-left: 40px;"></span>（6）永久性地、不可撤销地删除您当前使用的本网站账户项下的所有学习数据；
          <br><span style="padding-left: 40px;"></span>（7）采取上列措施之外的其他的措施。
          <br><br>6、本网站保留随时地、不事先通知地、不需要任何理由地、单方面地中止、终止本协议或提供相关学习服务的权利。该等中止、终止，可能是因为国家法律、法规、政策及国家机关的命令或者其他的诸如地震、火灾、海啸、台风、罢工、战争等不可抗力事件，还可能是上列原因之外的其他原因。若本网站的该等中止、终止行为给您造成任何损失的，您同意不向本网站主张任何赔偿或其他责任。
          <br><br> 7、账户使用与保管
          <br><span style="padding-left: 40px;"></span>（1）本网站有权审查您注册所提供的身份信息是否真实、有效，并应积极地采取技术与管理等合理措施保障您账户的安全、有效；您有义务妥善保管其账户及密码，并正确、安全地使用您的账户及密码。任何一方未尽上述义务导致账户密码遗失、账户被盗等情形而给您和他人的民事权利造成损害的，应当承担由此产生的法律责任。
          <br><span style="padding-left: 40px;"></span>（2）用户注册账号的所有权归本网站所有，注册用户享有账号的使用权，用户账号不能用于买卖、租赁等用途。账号的实际使用人和注册人必须一致，否则即构成违约，本网站有权采取冻结账号、停用账号等措施。
          <br><span style="padding-left: 40px;"></span>（3）您发现您的账户或密码被他人非法使用或有使用异常的情况的，应及时根据本网站公布的处理方式通知本网站，并有权通知本网站采取措施暂停该账户的登录和使用。 
          <br><span style="padding-left: 40px;"></span>（4）本网站根据您的通知采取措施暂停用户账户的登录和使用的，本网站应当要求您提供并核实与其注册身份信息相一致的个人有效身份信息。 
          <br><span style="padding-left: 40px;"></span>（5）本网站核实您所提供的个人有效身份信息与所注册的身份信息相一致的，应当及时采取措施暂停用户账户的登录和使用。 
          <br><span style="padding-left: 40px;"></span>（6）本网站违反（5）款项的约定，未及时采取措施暂停用户账户的登录和使用，因此而给您造成损失的，应当承担其相应的法律责任。
          <br><span style="padding-left: 40px;"></span>（7）您没有提供真实的个人有效身份证件或者您提供的个人有效身份证件与所注册的身份信息不一致的，本网站有权拒绝您依据本条第（3）项提出的请求。
          <br><span style="padding-left: 40px;"></span>（8）您为了维护您的合法权益，向本网站提供与所注册的身份信息相一致的个人有效身份信息时，本网站应当为您提供账户注册人证明、原始注册信息等必要的协助和支持，并根据需要向有关行政机关和司法机关提供相关证据信息资料。
          <br><br> 8、服务的中止与终止 
          <br><span style="padding-left: 40px;"></span>（1）您有发布违法信息、严重违背社会公德、以及其他违反法律禁止性规定的行为，本网站有权立即终止对您提供服务。
          <br><span style="padding-left: 40px;"></span>（2）您在接受本网站服务时实施违反约定或相关法规的不正当行为的，本网站有权终止对您提供服务。
          <br><span style="padding-left: 40px;"></span>（3）您没有以真实的个人身份信息进行注册，或实施违反本协议或相关法规的行为，本网站有权中止对您提供全部或部分服务。
          <br><br> 9、用户信息保护 
          <br><span style="padding-left: 40px;"></span>（1）本网站要求您提供与其个人身份有关的信息资料时，会事先以明确而易见的方式向您公开其隐私权保护政策和个人信息利用政策，并采取必要措施保护您的个人信息资料的安全。
          <br><span style="padding-left: 40px;"></span>（2）未经您许可本网站不得向任何第三方提供、公开或共享您注册资料中的姓名、个人有效身份证件号码、联系方式、家庭住址等个人身份信息，但下列情况除外：
          <br><span style="padding-left: 80px;"></span>A、您或您的监护人授权本网站披露的；
          <br><span style="padding-left: 80px;"></span>B、有关法律要求本网站披露的； 
          <br><span style="padding-left: 80px;"></span>C、司法机关或行政机关基于法定程序要求本网站提供的；
          <br><span style="padding-left: 80px;"></span>D、本网站为了维护自己合法权益而向您提起诉讼或者仲裁时；
          <br><span style="padding-left: 80px;"></span>E、应您的监护人的合法要求而提供您个人身份信息时。
          <br><br>四、适用法律<br>本服务条款的解释，效力及纠纷的解决，适用于中华人民共和国大陆法律。若您和本网站之间发生任何纠纷或争议，首先应友好协商解决，协商不成的，您在此完全同意将纠纷或争议提交协议签订地吉林省长春市人民法院管辖。
        </div>
        <div class="shadow2Button-s" style="top:5820px;"  @click="shadow=2">
          我已知悉
        </div>
        <div class="zhanweiXieyi"></div>
      </div>
    </div>
    <div class="shadowTip" v-if="shadowTip == 1">
      <div class="shadowContent">
          <img src="~@/assets/globalCourse/关闭.png" alt="" class="shadowIcon" @click="shadowTip=0;reDaojishiTip()">
          <div class="shadowText1">切换自主学习模式提示</div>
          <div class="shadowText2">当您切换至自主学习模式后，可自由安排学习计划，无时限和作业要求，也可根据自己的兴趣和需求自由选择课程内容，学习过程可自定进度。<br>
              <span style="color:#FF6666 ;">请知悉：自主学习模式下不支持切换回集训营模式，且不提供结业证书。</span>
          </div>
          <div class="shadowButton1" v-if="waitingTip">确定切换 ({{ secondTip }}s)</div>
          <div class="shadowButton1-s" v-if="!waitingTip" @click="exchangeMode()">确定切换</div>
          <div class="shadowButton2" @click="shadowTip=0;reDaojishiTip()">我再想想</div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import {rootUrl} from '@/globalConfig'
import axios from 'axios'
axios.defaults.headers['Authorization'] = "Bearer " + localStorage.getItem("token")
export default {
  name: "globalCourse",
  inject: ["reload"], //调用刷新
  data() {
    return {
      login: false,
      startStudy: 1,
      courseId: 0,
      // fromUrl1:"",
      name: "",
      avatar: "",
      originalStatus: 1,
      learnStatus:0,
      level: 0,
      createTime: "",
      updateTime: "",
      desp: "本课程收录于2022吉林一号遥感开发者集训营基础班",
      evaluateCount: 0,
      //评价星星数
      assessStarNum: 0,
      pageShow: 1,
      // 课程列表
      videoList: [],
      //视频播放是否全部完成
      videoWatchOver: false,
      introduction: "",
      teacherInfo: "",
      commentLength: 0,
      commentList: [],
      commentList1: [],
      //是否点赞
      dianzan: false,
      dianzanCount: 0,
      commentIsable: false,
      commentIsable1: [],
      commentIsable2: [[]],
      //评论回复
      contentDes: "",
      contentDes1: [],
      contentDes2: [],
      textOverFlow: false,
      textOverFlow1: [],
      textOverFlow2: [],
      //是否可以提交发布
      commentIsEnter: false,
      commentIsEnter1: [],
      commentIsEnter2: [],
      moreComment: false,
      moreComment1: false,
      videoListLength: 0,
      //删除
      userId: "",
      //复制
      str: "",
      // 作业阴影
      shadow: 0,
      // 阴影作业名称
      courseTitle: "视频1",
      //完成课程数量
      videoNum: 0,
      //完成课程列表
      videoFinishList:[],
      //开始学习阴影
      second: 5,
      waiting: true,
      timer: "",
      xianxia: false,
      //倒计时
      djsDay: 89,
      djsHour: 23,
      djsMin: 59,
      djsSecond: 59,
      //首次学习
      firstStatus: 0,
      haveTime: 0,
      timer1: "",
      //协议
      xieyi:false,
      sensitiveWordList:[],
      //课程时长列表
      videoTimeList:[],
      //判断是集训营模式还是自主学习模式
      mode:0,
      shadowTip:0,
      secondTip: 5,
      waitingTip: true,
      timerTip: "",
    };
  },
  methods: {
    step:function(i){
        return "step"+i
    },
    //实名权限检查与处理（培训班版）
    checkAndHandleAuthentication(){
      console.log("进入实名检查")
      let loginUserId=localStorage.getItem('userId');//是否已登录
      let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
      console.log(loginUserId,authentication)
      console.log(localStorage.getItem('preRoute'))
      if(!loginUserId){
        //上线前修改
        this.jumpWithPermission('仅登录','/Login','/learn/courseShow?courseId='+this.courseId)
      }
      else if(authentication!='0'){
        this.jumpWithPermission('仅实名','/Authentication','/learn/courseShow?courseId='+this.courseId)
      }
      return true;
    },
    //带权限判断的跳转
    jumpWithPermission(type,path,fromUrl){
      //path:需要跳转到的路由；fromUrl：如果权限不满足，满足后回跳的路由
      //注意：fromUrl必须为包含本项目router中base的相对地址，如商城个人中心为：/store/UserCenter
      let loginUserId=localStorage.getItem('userId');//是否已登录
      let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
      if(type=='可游客'){
        if(fromUrl){
          window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
        }
        else {
          window.open(rootUrl+path,"_self")
        }
      }else if(type=='仅登录'){
        //已登录
        if(loginUserId){
          if(fromUrl){
            window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
          }
          else {
            window.open(rootUrl+path,"_self")
          }
        }
        //未登录
        else {
          if(fromUrl){
            window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
          }
          else {
            window.open(rootUrl+'/Login',"_self")
          }
        }
      }else if(type=='仅实名'){
        //已登录
        if(loginUserId){
          //已实名
          if(authentication=='0'){
            if(fromUrl){
              window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
            }
            else {
              window.open(rootUrl+path,"_self")
            }
          }
          //未实名
          else {
            window.open(rootUrl+'/Authentication',"_self")
          }

        }
        //未登录
        else {

          if(fromUrl){
            window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
          }
          else {
            window.open(rootUrl+'/Login',"_self")
          }
        }
      }
    },
    getCourseData() {
      this.courseId = localStorage.getItem("courseId");
      let courseIds = this.$route.query.courseId;
      let courseId = "";
      if (courseIds != undefined&&courseIds!=null&&courseIds!='') {
        localStorage.setItem("courseId", courseIds);
        courseId = courseIds
      } else {
        courseId = this.courseId
      }
      console.log("课程id",courseId);
      this.axios
        .get("/learn_back/course/courseDetail/listDetail", {
          params:{
            courseId:courseId
          }
        }, {
          headers: {
            Authorization: "Bearer " + this.getKey(),
          },
        })
        .then((res) => {
          console.log("课程res",res);
          let resData = res.data;
          if (resData.msg!= "操作成功") {
            alert("课程暂无视频");
          } else  {
            // console.log(resData.data.commentList)
            this.assessStarNum = resData.data.lastEvaluateStar;
            this.name = resData.data.name;
            this.avatar = resData.data.avatar;
            this.originalStatus = resData.data.originalStatus;
            this.learnStatus=resData.data.learnStatus
            this.level = resData.data.level;
            this.createTime = resData.data.createTime;
            this.updateTime = resData.data.updateTime;
            // console.log(this.updateTime)
            this.desp = resData.data.desp;
            this.evaluateCount = resData.data.evaluateCount;
            let evaluateStar = resData.data.evaluateStar;
            this.getStarCount(evaluateStar);
            this.videoList = resData.data.videoList;
            // console.log(this.videoList)
            this.videoListLength = resData.data.videoList.length;
            for(let i =0;i<this.videoListLength;i++){
              if(this.videoList[i].learnStatus==1){
                this.videoFinishList.push(i)
              }
              let a = this.videoList[i].length.toString().split(".")
              let str = a[0]+"分"+a[1]+"秒"
              this.videoTimeList.push(str)
            }
            // console.log(this.videoTimeList)
            let videoNum = 0;
            let homeworkNum = 0;
            let homeworkCount = 0;
            resData.data.videoList.forEach((item) => {
              if (item.learnStatus == 1) {
                videoNum++;
              }
              if (
                item.homeworkStatus == 1 &&
                item.courseHomework != "" &&
                item.courseHomework != null
              ) {
                homeworkNum++;
              }
              if (item.courseHomework != "" && item.courseHomework != null) {
                homeworkCount++;
              }
            });
            if (videoNum == 0) {
              this.startStudy = 1;
            } else if (videoNum > 0 && videoNum < this.videoListLength) {
              this.startStudy = 2;
            } else if (videoNum == this.videoListLength) {
              if (homeworkNum < homeworkCount) {
                this.startStudy = 3;
              } else if (homeworkNum == homeworkCount) {
                this.startStudy = 4;
              }
            }
            this.videoNum = videoNum;
            if (videoNum == this.videoListLength && videoNum != 0) {
              this.videoWatchOver = true;
            } else {
              this.videoWatchOver = false;
            }
            this.introduction = resData.data.introduction;
            this.teacherInfo = resData.data.teacherInfo;
            this.commentLength = resData.data.commentCount;
          
          }
        });
    },
    getCommentData(){
      this.commentList = [];
      this.courseId = localStorage.getItem("courseId");
      let courseIds = this.$route.query.courseId;
      // let itemType = this.$route.query.type;
      // if (itemType == 1) {
      //   this.pageShow = 1;
      // } else if (itemType == 2) {
      //   this.pageShow = 2;
      // }
      this.pageShow = 2
      let courseId = "";
      if (courseIds != undefined&&courseIds!=null&&courseIds!='') {
        localStorage.setItem("courseId", courseIds);
        courseId = courseIds
      } else {
        courseId = this.courseId
      }
      console.log("this.getKey()",this.getKey());
      this.axios.get("/learn_back/course/comment/list", {
          params:{
            id:courseId
          }
        }, {
          headers: {
            Authorization: "Bearer " + this.getKey(),
          },
        })
        .then((res) => {
          let resData = res.data;
          console.log("获取评论",resData);
           if(resData.msg == "操作成功"){
            //判断评论是否为空
            if (this.commentLength > 0) {
              let goLoginId = document.getElementById("goLoginId");
              goLoginId.style.marginBottom = "54px";
            }
            // this.commentList = resData.data;
            this.commentList1 = resData.data;
            for (let i = 0; i < resData.data.length; i++) {
              this.commentIsable2[i] = new Array();
              this.commentIsable1[i] = false;
              if(resData.data[i].replyList){
                for (
                  let j = 0;
                  j < resData.data[i].replyList.length;
                  j++
                ) {
                  this.commentIsable2[i][j] = false;
                }
              }
            }
            //评论展示个数控制
            let pageShow = this.$route.query.pageShow;
            if (pageShow == 2) {
              this.commentList = resData.data;
              console.log(this.commentList);
              this.moreComment = true;
            } 
            else {
              if (this.moreComment1) {
                this.commentList = resData.data;
              } 
              else {
                if (resData.data.length > 3) {
                  this.commentList.push(resData.data[0]);
                  this.commentList.push(resData.data[1]);
                  this.commentList.push(resData.data[2]);
                  this.moreComment = true;
                  console.log(this.commentList);
                } 
                else {
                  this.commentList = resData.data;
                }
                console.log(this.commentList)
              }
            }
           }else {
              alert("暂无评论")
           }
        })
    },
    //简洁版获取接口信息
    getData() {
      this.courseId = localStorage.getItem("courseId");
      var userInfo = {
        courseId: this.courseId,
      };
      this.axios
        .get("/learn_back/course/comment/list", {
          params:{
            courseId:this.courseId
          }
        }, {
          headers: {
            Authorization: "Bearer " + this.getKey(),
          },
        })
        .then((res) => {
          let resData = res.data;
          if (resData.msg!= "操作成功") {
            alert("课程暂无视频");
          } else{
            this.easyCommentList = resData.data;
            // console.log(resData.data.commentList)
          }
        });
    },
    goHomework(learnStatus, item, homeworkStatus, title) {
      if(this.checkAndHandleAuthentication()&&this.$store.state.user.authentication==0){
        this.commentIsable = true;
        this.axios
          .get("/learn_back/course/register/queryCourseRegisterStatus", {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          })
          .then((res) => {
            let status = res.data.data.onlineStatus;
            if (status == 0) {
              this.$router.push({path:'/signInContent',query:{'type':1}})
            } else if (status == 1 || status == 3) {
              this.$router.push("/signInResult");
            } else {
              if(this.mode==2){
                this.$router.push({
                  path: "/homeWork",
                  query: { homeworkId: item, homeworkStatus: homeworkStatus },
                })
              }else{
                if(learnStatus==1){
                  this.$router.push({
                  path: "/homeWork",
                  query: { homeworkId: item, homeworkStatus: homeworkStatus },
                })
                }else{
                  this.shadow = 1;
                  this.courseTitle = title;
                }
              }
             
            }
          });
      }
      
    },
    goVideo(item, index) {
      if(this.checkAndHandleAuthentication()&&this.$store.state.user.authentication==0){
        this.commentIsable = true;
        this.axios
          .get("/learn_back/course/register/queryCourseRegisterStatus", {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          })
          .then((res) => {
            let status = res.data.data.onlineStatus;
            if (status == 0) {
              this.$router.push({path:'/signInContent',query:{'type':1}})
            } else if (status == 1 || status == 3) {
              this.$router.push("/signInResult");
            } else {
              if(this.mode!=2){
                if (this.firstStatus == 0) {
                  this.dajishiOn();
                  this.shadow = 2;
                } else {
                  this.$router.push({
                    path: "/coursePlay",
                    query: {
                      videoId: item,
                      videoList: this.videoList,
                      index: index,
                    },
                  })
                }
              }else{
                this.$router.push({
                  path: "/coursePlay",
                  query: {
                    videoId: item,
                    videoList: this.videoList,
                    index: index,
                  },
                })
              }
            }
          });
      }
    },
    //pageShow=2
    goLogin() {
      let url = "/courseShow";
      this.pageShow = 2;
      this.$router.push({
        path: "/Login?returnUrl=" + url,
        query: { type: 2 },
      });
    },
    getKey() {
      return localStorage.getItem("token");
    },
    //pageShow=1
    goStudy() {
      if (!this.commentIsable) {
        let url = "/courseShow";
        this.$router.push({
          path: "/Login?returnUrl=" + url,
          query: { type: 1 },
        });
      } else {
        this.axios
          .get("/learn_back/course/register/queryCourseRegisterStatus", {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          })
          .then((res) => {
            let status = res.data.data.onlineStatus;
            // console.log(status)
            if (status == 0) {
              this.$router.push({path:'/signInContent',query:{'type':1}})
            } else if (status == 1 || status == 3) {
              this.$router.push("/signInResult");
            } else {
              this.$router.push("/courseShow");
            }
          });
      }
    },
    goStudy1() {
      if(this.checkAndHandleAuthentication()&&this.$store.state.user.authentication==0) {
        this.axios
          .get("/learn_back/course/register/queryCourseRegisterStatus", {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          })
          .then((res) => {
            let status = res.data.data.onlineStatus;
            if (status == 0) {
              this.$router.push({path:'/signInContent',query:{'type':1}})
            } else if (status == 1 || status == 3) {
              this.$router.push("/signInResult")
            } else {
              if (this.firstStatus == 0) {
                this.dajishiOn()
                this.shadow = 2;
              } else {
                this.$router.push({
                          path: "/coursePlay",
                          query: {
                            videoId: this.videoList[0].id,
                            videoList: this.videoList,
                            index: 0,
                          },
                        })
              }

            }
          })
      }
    },
    goStudy2() {
      for(let i=0;i<this.videoFinishList.length;i++){
        if(this.videoFinishList[i]!=i){
          this.goVideo(this.videoList[i].id, i);
          break
        }else{
          if(i==this.videoFinishList.length-1){
            this.goVideo(this.videoList[i+1].id, i+1);
            break
          }
        }
      }
    },
    goStudy3() {
      for (let i = 0; i < this.videoListLength; i++) {
        if (
          this.videoList[i].courseHomework != null &&
          this.videoList[i].courseHomework != ""
        ) {
          if (this.videoList[i].homeworkStatus == 0) {
            this.goHomework(
              1,
              this.videoList[i].courseHomework.id,
              0,
              this.videoList[i].courseHomework.name
            );
            break
          }
        }
      }
    },
    goStudy4() {
      this.goVideo(this.videoList[0].id, 0);
    },
    assessStar(num) {
      if(this.checkAndHandleAuthentication()&&this.$store.state.user.authentication==0){
        this.assessStarNum = num;
        var inputForm = new FormData();
        inputForm.append("courseId", this.courseId);
        inputForm.append("star", num);
        this.axios
          .post("/learn_back/course/evaluate/sendEvaluateInfo",{
            courseId: this.courseId,
            userId: this.userId,
            star: num
          }, {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          })
          .then((res) => {
            let resData = res.data;
            if (resData.code !=200) {
              alert("提交评价失败");
            } else {
              console.log("提交评价成功");
            }
          });
      }
      
    },
    getStarCount(evaluateStar) {
      let starLeft1 = document.getElementById("starLeft1");
      let starLeft2 = document.getElementById("starLeft2");
      let starLeft3 = document.getElementById("starLeft3");
      let starLeft4 = document.getElementById("starLeft4");
      let starLeft5 = document.getElementById("starLeft5");
      let star = evaluateStar;
      // console.log(star)
      let width = 18;
      if (star >= 0 && star <= 1) {
        width = width * star;
        starLeft1.style.width = width + "px";
      } else if (star >= 1 && star <= 2) {
        width = width * (star - 1);
        starLeft1.style.width = "18px";
        starLeft2.style.width = width + "px";
      } else if (star >= 2 && star <= 3) {
        width = width * (star - 2);
        starLeft1.style.width = "18px";
        starLeft2.style.width = "18px";
        starLeft3.style.width = width + "px";
      } else if (star >= 3 && star <= 4) {
        width = width * (star - 3);
        starLeft1.style.width = "18px";
        starLeft2.style.width = "18px";
        starLeft3.style.width = "18px";
        starLeft4.style.width = width + "px";
      } else if (star >= 4 && star <= 5) {
        width = width * (star - 4);
        starLeft1.style.width = "18px";
        starLeft2.style.width = "18px";
        starLeft3.style.width = "18px";
        starLeft4.style.width = "18px";
        starLeft5.style.width = width + "px";
      } else {
        starLeft1.style.width = "18px";
        starLeft2.style.width = "18px";
        starLeft3.style.width = "18px";
        starLeft4.style.width = "18px";
        starLeft5.style.width = "18px";
      }
    },
    moreCommentClick() {
      this.moreComment = false;
      this.moreComment1 = true;
      this.commentList = [];
      this.commentList = this.commentList1;
      // console.log(this.commentList)
    },
    showtime(time) {
      let date =
        typeof time === "number"
          ? new Date(time)
          : new Date((time || "").replace(/-/g, "/"));
      let diff = (new Date().getTime() - date.getTime()) / 1000;
      let dayDiff = Math.floor(diff / 86400);
      let isValidDate =
        Object.prototype.toString.call(date) === "[object Date]" &&
        !isNaN(date.getTime());

      // if (!isValidDate) {
      //   window.console.error("不是有效日期格式"+time);
      // }
      const formatDate = function (date) {
        let today = new Date(date);
        let year = today.getFullYear();
        let month = ("0" + (today.getMonth() + 1)).slice(-2);
        let day = ("0" + today.getDate()).slice(-2);
        let hour = today.getHours();
        let minute = today.getMinutes();
        let second = today.getSeconds();
        return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
      };

      if (isNaN(dayDiff) || dayDiff < 0 || dayDiff >= 31) {
        return formatDate(date);
      }
      return (
        (dayDiff === 0 &&
          ((diff < 60 && "刚刚") ||
            (diff < 120 && "1分钟前") ||
            (diff < 3600 && Math.floor(diff / 60) + "分钟前") ||
            (diff < 7200 && "1小时前") ||
            (diff < 86400 && Math.floor(diff / 3600) + "小时前"))) ||
        (dayDiff === 1 && "昨天") ||
        (dayDiff < 7 && dayDiff + "天前") ||
        (dayDiff < 31 && Math.ceil(dayDiff / 7) + "周前") ||
        (dayDiff < 365 && Math.ceil(dayDiff / 30) + "月前") ||
        (dayDiff < 3650 && Math.ceil(dayDiff / 365) + "年前")
      );
    },
    areaNumJudge() {
      // console.log(123)
      let contentDes = this.contentDes.length;
      let textareaId = document.getElementById("textareaId");
      // let textareaTipId = document.getElementById("textareaTipId");
      if (contentDes < 1 || contentDes > 200) {
        textareaId.style.border = "1px solid #FF4040";
        this.textOverFlow = true;
        this.commentIsEnter = false;
      } else {
        this.textOverFlow = false;
        textareaId.style.border = "1px solid #C49760";
        this.commentIsEnter = true;
      }
    },
    areaNumJudge1(index) {
      let a = this.contentDes1[index];
      if (a != undefined && a != "" && a != null) {
        let contentDes1 = a.length;
        let contentDes1Id = document.getElementById("contentDesId" + index);
        // let textareaTipId = document.getElementById("textareaTipId");
        if (contentDes1 < 1 || contentDes1 > 200) {
          contentDes1Id.style.border = "1px solid #FF4040";
          this.textOverFlow1[index] = true;
          this.commentIsEnter1[index] = false;
        } else {
          this.textOverFlow1[index] = false;
          contentDes1Id.style.border = "1px solid #C49760";
          this.commentIsEnter1[index] = true;
        }
      }
    },
    areaNumJudge2(index) {
      let a = this.contentDes2[index];
      if (a != undefined && a != "" && a != null) {
        let contentDes2 = a.length;
        let contentDes2Id = document.getElementById("contentDes2Id" + index);
        // let textareaTipId = document.getElementById("textareaTipId");
        if (contentDes2 < 1 || contentDes2 > 200) {
          contentDes2Id.style.border = "1px solid #FF4040";
          this.textOverFlow2[index] = true;
          this.commentIsEnter2[index] = false;
        } else {
          this.textOverFlow2[index] = false;
          contentDes2Id.style.border = "1px solid #C49760";
          this.commentIsEnter2[index] = true;
        }
      }
    },
    commentEnter() {
      if(this.checkAndHandleAuthentication()&&this.$store.state.user.authentication==0){
        if (this.commentIsEnter&&this.contentDes!=null&&this.contentDes!=undefined&&this.contentDes!="") {
        var userInfo = {
          courseId: this.courseId,
          userId: this.userId,
          content: this.contentDes,
        };
        this.axios
          .post("/learn_back/course/comment/save", {
            courseId: this.courseId,
            content: this.contentDes,
          }, {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          })
          .then((res) => {
            let resData = res.data;
            if (resData.msg != "评论成功！") {
              alert("发布评论失败");
            } else {
              console.log("发布成功");
              this.contentDes = "";
              this.courseId = localStorage.getItem("courseId");
              var userInfo = {
                courseId: this.courseId,
              };
              this.axios
                .get("/learn_back/course/comment/list", {
                    params:{
                      id:this.courseId
                    }
                  }, {
                  headers: {
                    Authorization: "Bearer " + this.getKey(),
                  },
                })
                .then((res) => {
                  let resData = res.data;
                  if (resData.msg!= "操作成功") {
                    alert("课程暂无视频");
                  } else {
                    this.commentLength = resData.data.length;
                    for (let i = 0; i < resData.data.length; i++) {
                      this.commentIsable2[i] = new Array();
                      this.commentIsable1[i]=false
                      if(resData.data[i].replyList){
                        for (
                          let j = 0;
                          j < resData.data[i].replyList.length;
                          j++
                        ) {
                          this.commentIsable2[i][j] = false;
                        }
                      }
                    }
                    let easyCommentList = resData.data;
                    if (this.moreComment) {
                      this.commentList = [];
                      this.commentList.push(easyCommentList[0]);
                      this.commentList.push(easyCommentList[1]);
                      this.commentList.push(easyCommentList[2]);
                      this.commentList1 = easyCommentList;
                    } else {
                      this.commentList = easyCommentList;
                    }
                  }
                });
            }
          });
      }
      }
     
    },
    //回复评论
    commentEnter1(index, commentId,replyId) {
      if(this.checkAndHandleAuthentication()&&this.$store.state.user.authentication==0){
        if (this.commentIsEnter1[index]&&this.contentDes1[index]!=null&&this.contentDes1[index]!=undefined&&this.contentDes1[index]!="") {
        this.axios
          .post("/learn_back/course/reply/save", {
            
              commentId: commentId,
              content: this.contentDes1[index],
              replyId: "",
            
          }, {
            headers: {
              "Authorization": "Bearer " + this.getKey(),
              'Content-Type': 'application/json',
            },
          })
          .then((res) => {
            let resData = res.data;
            if (resData.code != 200) {
              alert("发布评论失败");
            } else {
              (this.commentIsable1 = []),
                (this.textOverFlow1 = []),
                (this.commentIsEnter1 = []),
                (this.contentDes1 = []),
                (this.courseId = localStorage.getItem("courseId"));
              var userInfo = {
                courseId: this.courseId,
              };
              this.axios
                .get("/learn_back/course/comment/list", {
                  params:{
                    id: this.courseId
                  }
                }, {
                  headers: {
                    Authorization: "Bearer " + this.getKey(),
                  },
                })
                .then((res) => {
                  let resData = res.data;
                  if (resData.msg!= "操作成功") {
                    alert("课程暂无视频");
                  } else {
                    for (let i = 0; i < resData.data.length; i++) {
                      this.commentIsable2[i] = new Array();
                      this.commentIsable1[i]=false
                      if(resData.data[i].replyList){
                        for (
                          let j = 0;
                          j < resData.data[i].replyList.length;
                          j++
                        ) {
                          this.commentIsable2[i][j] = false;
                        }
                      }
                    }
                    let easyCommentList = resData.data;
                    if (this.moreComment) {
                      this.commentList = [];
                      this.commentList.push(easyCommentList[0]);
                      this.commentList.push(easyCommentList[1]);
                      this.commentList.push(easyCommentList[2]);
                      this.commentList1 = easyCommentList;
                    } else {
                      this.commentList = easyCommentList;
                    }
                  }
                });
            }
          });
      }
      }
    
    },
    commentEnter2(index, commentId, replyId) {
      if(this.checkAndHandleAuthentication()&&this.$store.state.user.authentication==0){
        if (this.commentIsEnter2[index]&&this.contentDes2[index]!=null&&this.contentDes2[index]!=undefined&&this.contentDes2[index]!="") {
        var userInfo = {
          commentId: commentId,
          replyId: replyId,
          content: this.contentDes2[index],
        };
        this.axios
          .post("/learn_back/course/reply/save", {
            
              commentId: commentId,
              content: this.contentDes2[index],
              replyId: replyId,
            
          }, {
            headers: {
              Authorization: "Bearer " + this.getKey(),
              'Content-Type': 'application/json'
            },
          })
          .then((res) => {
            let resData = res.data;
            if (resData.code != 200) {
              alert("发布评论失败");
            } else {
              // console.log("发布成功")
              // this.commentIsable2=[],
              (this.textOverFlow2 = []),
                (this.commentIsEnter2 = []),
                (this.contentDes2 = []);
              this.courseId = localStorage.getItem("courseId");
              var userInfo = {
                courseId: this.courseId,
              };
              this.axios
                .get("/learn_back/course/comment/list", {
                  params:{
                    id: this.courseId
                  }
                }, {
                  headers: {
                    Authorization: "Bearer " + this.getKey(),
                  },
                })
                .then((res) => {
                  let resData = res.data;
                  if (resData.msg!= "操作成功") {
                    alert("课程暂无视频");
                  } else {
                    for (let i = 0; i < resData.data.length; i++) {
                      this.commentIsable2[i] = new Array();
                      this.commentIsable1[i]=false
                      if(resData.data[i].replyList){
                        for (
                          let j = 0;
                          j < resData.data[i].replyList.length;
                          j++
                        ) {
                          this.commentIsable2[i][j] = false;
                        }
                      }
                    }
                    let easyCommentList = resData.data;
                    if (this.moreComment) {
                      this.commentList = [];
                      this.commentList.push(easyCommentList[0]);
                      this.commentList.push(easyCommentList[1]);
                      this.commentList.push(easyCommentList[2]);
                      this.commentList1 = easyCommentList;
                    } else {
                      this.commentList = easyCommentList;
                    }
                  }
                });
            }
          });
      }
      }
    
    },
    replyComment(index) {
      if (this.checkAndHandleAuthentication()&&this.$store.state.user.authentication==0) {
        this.commentIsable1[index] = true;
        // console.log(this.commentIsable1.length)
        for(let i=0;i<this.commentIsable1.length;i++){
            if(i!=index){
                this.commentIsable1[i]=false
            }
        }
        for(let i=0;i<this.commentIsable2.length;i++){
          for(let j=0;j<this.commentIsable2[i].length;j++){
            this.commentIsable2[i][j]=false
          }
        }
        this.$forceUpdate();
      } 
    },
    replyComment2(index, index1) {
      if (this.checkAndHandleAuthentication()&&this.$store.state.user.authentication==0) {
        this.commentIsable2[index][index1] = true;
        console.log(this.commentIsable2.length)

        for(let i=0;i<this.commentIsable2.length;i++){
          this.commentIsable1[i]=false
          for(let j=0;j<this.commentIsable2[i].length;j++){
            if(i!=index || j!=index1){
              this.commentIsable2[i][j] = false;
            }
          }
        }
        this.$forceUpdate();
      } 
    },
    dianZan(id, id1) {
      if (this.checkAndHandleAuthentication()&&this.$store.state.user.authentication==0) {
        var userInfo = {
          commentId: id,
          replyId: id1,
          likeStatus: "0",
        };
        this.axios
          .post("/learn_back/course/comment/operateUserLike", {
            courseId:this.courseId,
            commentId: id,
            replyId: id1,
          }, {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          })
          .then((res) => {
            let resData = res.data;
            if (res.data.code !== 200) {
              alert(resData.msg);
            } else {
              console.log(resData.data);
              this.courseId = localStorage.getItem("courseId");
              var userInfo = {
                courseId: this.courseId,
              };
              this.axios
                .get("/learn_back/course/comment/list", {
                  params:{
                    id: this.courseId
                  }
                }, {
                  headers: {
                    Authorization: "Bearer " + this.getKey(),
                  },
                })
                .then((res) => {
                  let resData = res.data;
                  if (resData.msg!= "操作成功") {
                    alert("课程暂无视频");
                  } else if (resData.success) {
                    for (let i = 0; i < resData.data.length; i++) {
                      this.commentIsable2[i] = new Array();
                      this.commentIsable1[i]=false
                      if(resData.data[i].replyList){
                        for (
                          let j = 0;
                          j < resData.data[i].replyList.length;
                          j++
                        ) {
                          this.commentIsable2[i][j] = false;
                        }
                      }
                    }
                    let easyCommentList = resData.data;
                    if (this.moreComment) {
                      this.commentList = [];
                      this.commentList.push(easyCommentList[0]);
                      this.commentList.push(easyCommentList[1]);
                      this.commentList.push(easyCommentList[2]);
                      this.commentList1 = easyCommentList;
                    } else {
                      this.commentList = easyCommentList;
                    }
                    
                  }
                });
            }
          });
      }
    },
    dianZanOff(id, id1) {
      if(this.checkAndHandleAuthentication()&&this.$store.state.user.authentication==0){
        var userInfo = {
        commentId: id,
        replyId: id1,
        likeStatus: "1",
      };
      this.axios
        .post("/learn_back/course/comment/operateUserLike", {
            courseId:this.courseId,
            commentId: id,
            replyId: id1,
          },{
          headers: {
            Authorization: "Bearer " + this.getKey(),
          },
        })
        .then((res) => {
          let resData = res.data;
          if (res.data.code !== 200) {
            alert("点赞失败");
          } else {
            console.log(resData.data);
            this.courseId = localStorage.getItem("courseId");
            var userInfo = {
              id: this.courseId,
            };
            this.axios
              .get("/learn_back/course/comment/list", {
                params:{
                  id:this.courseId
                }
              }, {
                headers: {
                  Authorization: "Bearer " + this.getKey(),
                },
              })
              .then((res) => {
                let resData = res.data;
                if (resData.msg!= "操作成功") {
                  alert("课程暂无视频");
                } else {
                  
                  for (let i = 0; i < resData.data.length; i++) {
                    this.commentIsable2[i] = new Array();
                    this.commentIsable1[i]=false
                    if(resData.data[i].replyList){
                        for (
                          let j = 0;
                          j < resData.data[i].replyList.length;
                          j++
                        ) {
                          this.commentIsable2[i][j] = false;
                        }
                      }
                  }
                  
                  let easyCommentList = resData.data;
                  if (this.moreComment) {
                    this.commentList = [];
                    this.commentList.push(easyCommentList[0]);
                    this.commentList.push(easyCommentList[1]);
                    this.commentList.push(easyCommentList[2]);
                    this.commentList1 = easyCommentList;
                  } else {
                    this.commentList = easyCommentList;
                  }
                    
                }
              });
          }
        });
      }
      
    },
    deleteComment(id, id1, index, index1) {
      if (this.checkAndHandleAuthentication()&&this.$store.state.user.authentication==0) {
        var userInfo = {
          commentId: id,
          replyId: id1,
        };
        this.axios
          .post("/learn_back/course/comment/delete", {
              id:id
          }, {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          })
          .then((res) => {
            let resData = res.data;
            if (resData.code != 200) {
              alert("删除评价失败");
            } else {
              // console.log(resData.data)
              console.log("删除评价成功");
              this.courseId = localStorage.getItem("courseId");
              var userInfo = {
                courseId: this.courseId,
              };
              this.axios
                .get("/learn_back/course/comment/list", {
                  params:{
                    id:this.courseId
                  }
                }, {
                  headers: {
                    Authorization: "Bearer " + this.getKey(),
                  },
                })
                .then((res) => {
                  let resData = res.data;
                  if (resData.code != 200) {
                    alert("课程暂无视频");
                  } else {
                    this.commentLength = resData.data.length;
                    for (let i = 0; i < resData.data.length; i++) {
                      this.commentIsable2[i] = new Array();
                      this.commentIsable1[i]=false
                      if(resData.data[i].replyList){
                        for (
                          let j = 0;
                          j < resData.data[i].replyList.length;
                          j++
                        ) {
                          this.commentIsable2[i][j] = false;
                        }
                      }
                    }
                    let easyCommentList = resData.data;
                    if (this.moreComment) {
                      this.commentList = [];
                      this.commentList.push(easyCommentList[0]);
                      this.commentList.push(easyCommentList[1]);
                      this.commentList.push(easyCommentList[2]);
                      this.commentList1 = easyCommentList;
                    } else {
                      this.commentList = easyCommentList;
                    }
                  }
                });
            }
          });
      } 
    },
    deleteContent(id, id1, index, index1) {
      if (this.checkAndHandleAuthentication()&&this.$store.state.user.authentication==0) {
        var userInfo = {
          commentId: id,
          replyId: id1,
        };
        this.axios
          .post("/learn_back/course/reply/delete", {
              id:id1
          }, {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          })
          .then((res) => {
            let resData = res.data;
            if (resData.code != 200) {
              alert("删除评价失败");
            } else {
              // console.log(resData.data)
              console.log("删除评价成功");
              this.courseId = localStorage.getItem("courseId");
              var userInfo = {
                courseId: this.courseId,
              };
              this.axios
                .get("/learn_back/course/comment/list", {
                  params:{
                    id:this.courseId
                  }
                }, {
                  headers: {
                    Authorization: "Bearer " + this.getKey(),
                  },
                })
                .then((res) => {
                  let resData = res.data;
                  if (resData.code != 200) {
                    alert("课程暂无视频");
                  } else {
                    this.commentLength = resData.data.length;
                    for (let i = 0; i < resData.data.length; i++) {
                      this.commentIsable2[i] = new Array();
                      this.commentIsable1[i]=false
                      if(resData.data[i].replyList){
                        for (
                          let j = 0;
                          j < resData.data[i].replyList.length;
                          j++
                        ) {
                          this.commentIsable2[i][j] = false;
                        }
                      }
                    }
                    let easyCommentList = resData.data;
                    if (this.moreComment) {
                      this.commentList = [];
                      this.commentList.push(easyCommentList[0]);
                      this.commentList.push(easyCommentList[1]);
                      this.commentList.push(easyCommentList[2]);
                      this.commentList1 = easyCommentList;
                    } else {
                      this.commentList = easyCommentList;
                    }
                  }
                });
            }
          });
      }
    },
    copyUrl() {
      var currentPath = window.document.location.href;
      var input = document.createElement("input");
      document.body.appendChild(input);
      input.value = currentPath;
      input.select();
      try {
        //进行复制到剪切板
        if (document.execCommand("Copy", true, null)) {
          //如果复制成功
          alert("复制链接成功！赶紧分享给你的好友吧~");
          //隐藏input框
          input.hidden = "hidden";
        } else {
          //如果复制失败
          alert("复制失败！");
        }
      } catch (err) {
        //如果报错
        alert("复制错误！");
      }
    },
    xianxiaJudge() {
      if (this.xianxia) {
        this.shadow = 2;
      } else {
        this.shadow = 0;
      }
    },
    daojishi() {
      if (this.second <= 0) {
        this.waiting = false;
        clearInterval(this.timer);
      } else {
        this.second--;
      }
    },
    dajishiOn() {
      this.$nextTick(() => {
        this.timer = setInterval(this.daojishi, 1000);
      });
    },
    firstStudy() {
      this.axios
        .post("/learn_back/course/courseLearn/sendUserFirstLearnStatus/0", null, {
          headers: {
            Authorization: "Bearer " + this.getKey(),
          },
        })
        .then((res) => {
          let resData = res.data;
          if (resData.msg != "操作成功") {
            console.log("获取用户信息失败")
          } else {
            //mode 0 集训营 1 线下 2 自主学习
            this.mode=resData.data.mode
            this.$store.state.mode=this.mode 

            console.log(this.mode);
            this.firstStatus = resData.data.firstLearnStatus
            this.djsDay = resData.data.remainLearnTime[0]
            this.djsHour = resData.data.remainLearnTime[1]
            this.djsMin = resData.data.remainLearnTime[2]
            this.djsSecond = resData.data.remainLearnTime[3]
            let totalLearnStatus = resData.data.totalLearnStatus
                if(totalLearnStatus==0){
                    if(this.firstStatus==0){
                        this.haveTime=0
                    }else if(this.firstStatus==1){
                      if(this.djsDay<0||this.djsHour<0||this.djsMin<0||this.djsSecond<0){
                            this.haveTime=2
                        }else if(this.djsDay==0&&this.djsHour==0&&this.djsMin==0&&this.djsSecond==0){
                            this.haveTime=2
                        }else{
                            this.haveTime=1
                            this.effectiveTimeOn()
                        }
                    }
                }else if(totalLearnStatus==1){
                    this.haveTime=3
                }else{
                    this.haveTime=4
                } 
          }
        });
    },
    firstStudy1() {
      this.shadow = 0;
      this.axios
        .post("/learn_back/course/courseLearn/sendUserFirstLearnStatus/1", null, {
          headers: {
            Authorization: "Bearer " + this.getKey(),
          },
        })
        .then((res) => {
          let resData = res.data;
          if (resData.msg != "操作成功") {
            console.log("获取用户信息失败");
          } else {
            // console.log(resData.data.remainLearnTime)
            this.firstStatus = 1;
            // console.log(this.firstStatus)
            this.djsDay = resData.data.remainLearnTime[0];
            this.djsHour = resData.data.remainLearnTime[1];
            this.djsMin = resData.data.remainLearnTime[2];
            this.djsSecond = resData.data.remainLearnTime[3];
            this.haveTime = 1;
            this.effectiveTimeOn();
            this.$router.push({
                          path: "/coursePlay",
                          query: {
                            videoId: this.videoList[0].id,
                            videoList: this.videoList,
                            index: 0,
                          },
                        });
          }
        });
    },
    effectiveTime() {
      if (
        this.djsDay == 0 &&
        this.djsHour == 0 &&
        this.djsMin == 0 &&
        this.djsSecond == 0
      ) {
        this.haveTime = 2;
        clearInterval(this.timer1);
      } else {
        if (this.djsSecond <= 0) {
          this.djsSecond = 59;
          if (this.djsMin <= 0) {
            this.djsMin = 59;
            if (this.djsHour <= 0) {
              this.djsHour = 23;
              if (this.djsDay < 0) {
                this.haveTime = 2;
                clearInterval(this.timer1);
              } else {
                this.djsDay--;
              }
            } else {
              this.djsHour--;
            }
          } else {
            this.djsMin--;
          }
        } else {
          this.djsSecond--;
        }
      }
    },
    effectiveTimeOn() {
      this.$nextTick(() => {
        this.timer1 = setInterval(this.effectiveTime, 1000);
      });
    },
    //敏感词过滤
    makeSensitiveMap() {
      var result = {}
      var count = this.sensitiveWordList.length
      for (var i = 0; i < count; ++i) {
    var map = result;
    var word = this.sensitiveWordList[i];
    // 依次获取字
    for (var j = 0; j < word.length; ++j) {
      var ch = word.charAt(j);  // charAt() 方法可返回指定位置的字符。
      // 判断是否存在
      if (typeof(map[ch]) != "undefined") {
        map = map[ch];
        if (map["empty"]) {
          break;
        }
      }
      else {
        if (map["empty"]) {
          delete map["empty"];
        }
        map[ch] = {"empty":true};
        map = map[ch];
      }
    }
  }
  return result;
    },
    checkSensitiveWord (sensitiveMap, sentence) {
      let result = [];
      let count = sentence.length;
      let stack = [];
      let point = sensitiveMap;
      for (var i=0; i<count; i++) {
        var ch = sentence.charAt(i);
        var item = point[ch];
        if (typeof(item) == "undefined") {
          i = i - stack.length;
          stack = [];
          point = sensitiveMap;
        } else if (item["empty"]) {
          stack.push(ch);
          result.push(stack.join(""));
          stack = [];
          point = sensitiveMap;
        } else {
          stack.push(ch);
          point = item;
        }
      }
      return result;
    },
    daojishiTip() {
      if (this.secondTip <= 0) {
          this.waitingTip = false;
          clearInterval(this.timerTip);
      } else {
          this.secondTip--;
      }
    },
    dajishiOnTip() {
        this.$nextTick(() => {
            this.timerTip = setInterval(this.daojishiTip, 1000);
        });
    },
    reDaojishiTip(){
        this.waitingTip=true
        this.secondTip=5
        clearInterval(this.timerTip)
    },
    exchangeMode(){
      var userInfo = {
        education: '硕士',
        age: '27',
        sex: '1',
        major: "计算机科学与技术",
        company: "长光卫星",
        email: "121@qq.com"
      }
      this.axios.post(
        "/learn_back/course/register/saveFreeLearnCourseRegister", userInfo,
        {
          headers: {
            Authorization: "Bearer " + this.getKey(),
          },
        }
      ).then((res) => {
         console.log(res);
         this.mode=2
         this.shadowTip=0
        });
    }
  
  },
  mounted() {
    if(this.$store.state.user.authentication==0){
      this.commentIsable = true;
    }else{
      this.commentIsable = false;
    }
    this.firstStudy();
    this.getCourseData();
    axios.defaults.headers['Authorization'] = "Bearer " + localStorage.getItem("token")
  },
  created() {

  },
  watch:{
  },
  computed: {},
};
</script>
<style scoped>
.content {
  width: 100%;
  height: auto;
  background: #f5f5f6;
  padding-bottom: 54px;
  overflow: hidden;
  margin-top: 76px;
}
.content1280 {
  /* margin-top: 120px; */
  width: 1280px;
  height: auto;
  margin-left: calc(50% - 640px);
}
.top {
  position: relative;
  width: 100%;
  height: 54px;
}
.titleText1 {
  position: absolute;
  top: 16px;
  left: 0;
  width: 46px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #979797;
  line-height: 22px;
  cursor: pointer;
  text-align: left;
}
.courseTitle {
  position: relative;
  width: 100%;
  height: 378px;
  background-color: #ffffff;
}
.courseBackground {
  position: absolute;
  top: 54px;
  left: 0;
  width: 480px;
  height: 270px;
}
.courseTitleText1 {
  position: absolute;
  top: 54px;
  left: 534px;
  width: 1000px;
  height: 42px;
  font-size: 30px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3a3a3a;
  line-height: 42px;
  text-align: left;
}
.courseStatus{
  position: absolute;
  top: 54px;
  right: 0px;
  width:121px;
    height:107px;
}
.courseDetailImg1 {
  position: absolute;
  top: 116px;
  left: 534px;
  width: 96px;
  height: 26px;
  background: linear-gradient(134deg, #e9c384 0%, #c49760 100%);
  border-radius: 4px;
}
.courseDetailImg2 {
  position: absolute;
  top: 116px;
  left: 640px;
  width: 60px;
  height: 26px;
  background: linear-gradient(130deg, #00d5ff 0%, #00aaff 100%);
  border-radius: 4px;
}
.courseTitleText2 {
  position: absolute;
  top: 162px;
  left: 534px;
  width: 200px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #979797;
  line-height: 22px;
  text-align: left;
}
.courseDetailImg3 {
  position: absolute;
  top: 306px;
  left: 777px;
  width: 16px;
  height: 16px;
}
.courseTitleButton1 {
  position: absolute;
  top: 270px;
  right: 0;
  width: 150px;
  height: 54px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 27px;
  border: 1px solid #c49760;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #c49760;
  line-height: 54px;
  text-align: center;
  cursor: pointer;
}
.courseTitleButton1:hover {
  background: #c49760;
  border-radius: 27px;
  border: 1px solid #c49760;
  color: #ffffff;
}
.courseTitleButton2 {
  position: absolute;
  top: 270px;
  right: 0;
  width: 220px;
  padding-left: 27px;
  height: 54px;
  background: url(~@/assets/globalCourse/学习课程2.png);
  background-size: 100% 100%;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #c49760;
  line-height: 54px;
  cursor: pointer;
}
.courseTitleButton2:hover {
  background: url(~@/assets/globalCourse/学习课程1.png);
  background-size: 100% 100%;
  color: #ffffff;
}
.courseTitleButton3 {
  position: absolute;
  top: 270px;
  right: 0;
  width: 190px;
  padding-left: 27px;
  height: 54px;
  background: url(~@/assets/globalCourse/完成作业2.png);
  background-size: 100% 100%;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #c49760;
  line-height: 54px;
  cursor: pointer;
}
.courseTitleButton3:hover {
  background: url(~@/assets/globalCourse/完成作业1.png);
  background-size: 100% 100%;
  color: #ffffff;
}
.star {
  position: absolute;
  top: 0;
  left: 0;
  width: 18px;
  height: 18px;
}
.star1 {
  position: absolute;
  top: 304px;
  left: 534px;
  width: 18px;
  height: 18px;
}
.star2 {
  margin-top: 0px;
  margin-right: 10px;
  float: left;
  width: 18px;
  height: 18px;
  cursor: pointer;
}
.context6 {
  float: left;
  margin-top: 0;
  width: 48px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #c49760;
  line-height: 22px;
}
.conLine4 {
  margin-top: 116px;
  width: 1280px;
  height: 1px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.starLeft {
  position: absolute;
  top: 304px;
  left: 534px;
  width: 0px;
  height: 18px;
  overflow: hidden;
  z-index: 1;
}
.starRight {
  position: absolute;
  top: 304px;
  left: 534px;
  width: 18px;
  height: 18px;
}
.courseContent {
  width: 100%;
  margin-top: 10px;
  height: auto;
  background: #ffffff;
  overflow: hidden;
}
.courseCon1280 {
  margin-top: 0;
  width: 1280px;
  margin-left: calc(50% - 640px);
  height: auto;
  overflow: hidden;
}
.conText1 {
  float: left;
  margin-top: 38px;
  margin-left: 0;
  width: 85px;
  height: 58px;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #c49760;
  line-height: 58px;
  cursor: pointer;
  border-bottom: 2px solid #c49760;
}
.conText1-s {
  float: left;
  margin-top: 38px;
  margin-left: 0;
  width: 85px;
  height: 58px;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #979797;
  line-height: 58px;
  cursor: pointer;
}
.conText2 {
  float: left;
  margin-top: 38px;
  margin-left: 100px;
  width: auto;
  height: 58px;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #c49760;
  line-height: 58px;
  cursor: pointer;
  border-bottom: 2px solid #c49760;
}
.conText2-s {
  float: left;
  margin-top: 38px;
  color: #979797;
  margin-left: 100px;
  width: auto;
  height: 58px;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  line-height: 58px;
  cursor: pointer;
}
.conLine1 {
  float: left;
  margin-top: 95px;
  margin-left: -266px;
  width: 80px;
  height: 1px;
  background-color: #c49760;
}
.context3 {
  margin-top: 150px;
  margin-left: 0;
  margin-bottom: 39px;
  width: 180px;
  height: 28px;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #777777;
  line-height: 28px;
}
.smallCourseDetail {
  position: relative;
  margin-bottom: 32px;
  width: 1280px;
  height: 62px;
  /* background-color: pink; */
  overflow: hidden;
}
.conLine3 {
  margin-top: 56px;
  width: 1280px;
  height: 1px;
  background-color: rgba(0, 0, 0, 0.1);
}
.weiwancheng {
  position: absolute;
  width: 62px;
  height: 62px;
  top: 0;
  left: 0;
}
.videoArea {
  position: relative;
  margin-left: 80px;
  margin-top: 4px;
  width: 1280px;
  height: 20px;
}
.videoIcon {
  position: absolute;
  width: 24px;
  height: 20px;
  top: 0px;
  left: 0px;
}
.smallCourseTitle {
  /* position: absolute; */
  float: left;
  margin-top: 0px;
  margin-left: 39px;
  width: auto;
  height: 20px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #c49760;
  line-height: 20px;
}
.smallCourseTitle:hover {
  text-decoration: underline;
  font-weight: 600;
}
.smallCourseTitle1 {
  /* position: absolute; */
  float: left;
  margin-top: 2px;
  margin-left: 39px;
  width: auto;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #c49760;
  line-height: 22px;
  cursor: pointer;
}
.smallCourseTitle1:hover {
  text-decoration: underline;
  font-weight: 600;
}
.wanchengIcon {
  float: left;
  margin-top: 2px;
  margin-left: 18px;
  width: 18px;
  height: 18px;
}
.wanchengIcon1 {
  float: left;
  margin-top: 2px;
  margin-left: 18px;
  width: 18px;
  height: 18px;
}
.conText4 {
  position: absolute;
  top: 38px;
  left: 119px;
  width: 80px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #c49760;
  line-height: 22px;
  cursor: pointer;
}
.context5 {
  width: 1280px;
  height: auto;
  margin-top: 40px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #979797;
  line-height: 30px;
  text-align: justify;
}
.goLogin {
  margin-top: 148px;
  margin-left: calc(50% - 300px);
  width: 600px;
  height: 120px;
  background: #f5f5f6;
  border-radius: 16px;
  margin-bottom: 197px;
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #979797;
  line-height: 120px;
  text-align: center;
}
.writeComment {
  margin-top: 54px;
  width: 1280px;
  margin-bottom: 76px;
  height: 96px;
  background: #ffffff;
  border-radius: 4px;
  outline: none;
  border: 1px solid #c49760;
  padding-top: 16px;
  padding-left: 22px;
  padding-right: 22px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3a3a3a;
  line-height: 20px;
  resize: none;
}
.writeComment-s {
  margin-top: 27px;
  margin-bottom: 26px;
  margin-left: 27px;
  width: 1175px;
  height: 96px;
  background: #f7f7f7;
  border-radius: 4px;
  outline: none;
  border: 1px solid #c49760;
  padding-top: 16px;
  padding-left: 22px;
  padding-right: 22px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3a3a3a;
  line-height: 20px;
  resize: none;
}
.textareaTip {
  float: left;
  margin-top: -76px;
  margin-left: 23px;
  margin-bottom: 52px;
  width: 106px;
  height: 24px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ff4040;
  line-height: 24px;
}
.commentEnter {
  float: right;
  margin-right: 0px;
  margin-top: -64px;
  width: 76px;
  height: 40px;
  border-radius: 20px;
  border: 1px solid #c49760;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #c49760;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}
.commentEnter:hover {
  background: #c49760;
  border-radius: 20px;
  border: 1px solid #c49760;
  color: #ffffff;
}
.commentContent {
  /* margin-top: 1px; */
  margin-bottom: 40px;
  width: 1280px;
  height: auto;
  /* border-bottom: 1px solid pink; */
  /* background-color: pink; */
}
.userImg {
  position: absolute;
  top: 0;
  left: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.userName {
  position: absolute;
  top: 0;
  left: 54px;
  height: 40px;
  width: auto;
  font-size: 15px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3a3a3a;
  line-height: 40px;
  text-align: left;
}
.userComment {
  margin-top: 18px;
  width: 1225px;
  margin-left: 55px;
  height: auto;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3a3a3a;
  line-height: 24px;
  text-align: justify;
}
.userTime {
  position: absolute;
  top: 0;
  left: 0;
  width: auto;
  height: 19px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #979797;
  line-height: 20px;
  text-align: left;
}

.zhanwei {
  margin-top: 1px;
  margin-left: 0;
  width: 1225px;
  height: 30px;
  /* background-color: pink; */
}
.replyIcon {
  position: absolute;
  width: 18px;
  height: 14px;
  top: 4px;
  left: 1081px;
}
.dianzanIcon {
  position: absolute;
  top: 3px;
  left: 1171px;
  width: 15px;
  height: 14px;
  cursor: pointer;
}
.commentReply {
  margin-top: 24px;
  margin-left: 55px;
  width: 1226px;
  height: auto;
  background: #f7f7f7;
  border-radius: 6px;
  padding-bottom: 30px;
  overflow: hidden;
}
.commentLine {
  margin-top: 40px;
  width: 1280px;
  height: 1px;
  border-bottom: 1px solid #cccccc;
}
.clickMoreComment {
  margin-top: 90px;
  margin-left: calc(50% - 50px);
  margin-bottom: 107px;
  width: 100px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #979797;
  line-height: 20px;
  cursor: pointer;
}
.shadow {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}
.tip {
  position: absolute;
  top: calc(50% - 200px);
  left: calc(50% - 400px);
  width: 800px;
  height: 400px;
  background: #ffffff;
  border-radius: 16px;
}
.tipText1 {
  position: absolute;
  top: 46px;
  left: calc(50% - 50px);
  width: 100px;
  height: 28px;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3a3a3a;
  line-height: 28px;
  text-align: center;
}
.tipText2 {
  position: absolute;
  top: 143px;
  left: calc(50% - 400px);
  width: 800px;
  height: 36px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3a3a3a;
  line-height: 36px;
  text-align: center;
}
.tipText3 {
  position: absolute;
  top: 290px;
  left: calc(50% - 56px);
  width: 112px;
  height: 44px;
  background: #c49760;
  border-radius: 22px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 44px;
  text-align: center;
  cursor: pointer;
}
.shadow2White {
  position: absolute;
  top: calc(50% - 240px);
  left: calc(50% - 400px);
  width: 800px;
  height: 480px;
  background: #ffffff;
  border-radius: 16px;
}
.shadow3White {
  position: absolute;
  top: calc(50% - 240px);
  left: calc(50% - 400px);
  width: 800px;
  height: 480px;
  background: #ffffff;
  border-radius: 16px;
  overflow-y: scroll;
}
.text4 {
  position: absolute;
  top: 40px;
  left: calc(50% - 100px);
  width: 200px;
  height: 28px;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3a3a3a;
  line-height: 28px;
  text-align: center;
}
.xieyiText2{
  position: absolute;
  top: 129px;
  left: calc(50% - 300px);
  width: 600px;
height: 5590px;
font-size: 16px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 500;
color: #000000;
line-height: 30px;
text-align:justify;
}
.text6 {
  position: absolute;
  top: 103px;
  left: calc(50% - 300px);
  width: 600px;
  height: 180px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 500;
  color: #000000;
  line-height: 30px;
}
.shadowWhite {
  position: absolute;
  top:calc(50% - 290px);
  left: calc(50% - 400px);
  width: 800px;
  height: 580px;
  background: #ffffff;
  border-radius: 16px;
}
.shadow2Button {
  position: absolute;
  top: 397px;
  left: calc(50% - 75px);
  width: 150px;
  height: 44px;
  background: #cccccc;
  border-radius: 22px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 44px;
  text-align: center;
}
.shadow2Button-s {
  position: absolute;
  top: 397px;
  left: calc(50% - 75px);
  width: 150px;
  height: 44px;
  background: #c49760;
  border-radius: 22px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 44px;
  text-align: center;
  cursor: pointer;
}
.zhanweiXieyi{
  position: absolute;
  width: 100px;
  height: 100px;
  left: 50px;
  top: 5850px;
  background: transparent;
}
.xieyiSelect{
  position: absolute;
  top: 321px;
  left: 100px;
  width: 18px;
  height: 18px;
  cursor: pointer;
}
.xieyiText{
  position: absolute;
  top: 319px;
  left: 130px;
  width: 750px;
height: 22px;
font-size: 16px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #000000;
line-height: 22px;
text-align: left;
}
.text5 {
  position: absolute;
  top: 108px;
  left: calc(50% - 300px);
  width: 600px;
  height: 324px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 36px;
}
.shadowButton {
  position: absolute;
  top: 496px;
  left: calc(50% - 48px);
  width: 96px;
  height: 44px;
  background: #c49760;
  border-radius: 22px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 44px;
  text-align: center;
  cursor: pointer;
}
.timeLeft {
  position: relative;
  /* margin-top: 120px; */
  /* margin-bottom:20px; */
  width: 100%;
  height: 40px;
  background: #c49760;
  font-size: 14px;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: #ffffff;
  line-height: 40px;
  text-align: center;
}
.timeLeftIcon{
    position: absolute;
    top: 15px;
    left: calc(50% + 85px);
    width: 6px;
    height: 10px;
    cursor: pointer;
}
.timeLeftText1 {
  position: absolute;
  width: 800px;
  height: 40px;
  left: calc(50% - 400px);
}
.timeLeftText2 {
  position: absolute;
  width: 330px;
  height: 40px;
  left: 0;
  /* background-color: pink; */
  font-size: 14px;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: #ffffff;
  line-height: 40px;
  text-align: left;
}
.timeLeftText3 {
  position: absolute;
  left: 125px;
  width: 20px;
  height: 40px;
  /* background-color: pink; */
  font-family: PingFang SC;
  font-weight: 600;
  line-height: 40px;
  text-align: right;
}
</style>
<style scoped>
.changeMode{
  position: absolute;
  left: calc(50% + 460px);
  top: 5px;
  width: 180px;
  height: 30px;
  background: #C49760;
  border-radius: 15px;
  border: 1px solid #FFFFFF;
  cursor: pointer;
}
.changeModeText1{
  position: absolute;
  top: 8px;
  left: 21px;
  width: auto;
  height: 14px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 14px;
}
.changeModeIcon{
  position: absolute;
  top: 9px;
  left: 153px;
  width: 6px;
  height: 12px;
}
.shadowTip{
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  backdrop-filter: blur(2px);
}
.shadowContent{
  position: absolute;
  top: calc(50% - 200px);
  left: calc(50% - 400px);
  width: 800px;
  height: 400px;
  background: #FFFFFF;
  border-radius: 16px;
}
.shadowIcon{
  position: absolute;
  top: 0;
  right: -50px;
  width: 40px;
  height: 40px;
}
.shadowText1{
  position: absolute;
  top: 50px;
  width: 800px;
  height: 28px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 20px;
  color: #3A3A3A;
  line-height: 28px;
  text-align: center;
}
.shadowText2{
  position: absolute;
  top: 118px;
  left: 100px;
  width: 600px;
  height: 90px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #3A3A3A;
  line-height: 30px;
  text-align: justify;
  font-style: normal;
}
.shadowButton1{
  position: absolute;
  top: 306px;
  left: 243px;
  width: 150px;
  height: 44px;
  background: #CCCCCC;
  border-radius: 22px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 22px;
  line-height: 44px;
  text-align: center;
}
.shadowButton1-s{
  position: absolute;
  top: 306px;
  left: 243px;
  width: 150px;
  height: 44px;
  background: #C49760;
  border-radius: 22px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 22px;
  line-height: 44px;
  text-align: center;
  cursor: pointer;
}
.shadowButton2{
  position: absolute;
  top: 306px;
  left: 408px;
  width: 150px;
  height: 44px;
  background: #FFFFFF;
  border-radius: 22px;
  border: 1px solid #C49760;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #C49760;
  line-height: 44px;
  cursor: pointer;
  text-align: center;
}
</style>
